import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  messageWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-end',
    padding: theme.spacing(0.5, 1),
  },
  notMyMessage: {
    flexDirection: 'row-reverse',
  },

  messageContainer: {
    ...theme.mixins.appContainer,
    width: 'auto',
    maxWidth: '70%',
    padding: theme.spacing(0.5, 1),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0.5, 1),
    },
  },
  filesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));
